import { LRUCache } from "lru-cache";

const URL_CACHE_MAX_ENTRIES = 200;

// Safely below the backend's 6h signature expiry, so a cached URL is never
// handed out moments before it dies. Loaders reuse it for the same reason.
export const SIGNED_URL_SAFE_TTL_MS = 5 * 60 * 60 * 1000;

// lru-cache forbids null values; DENIED stands in for "signing refused".
const DENIED = Symbol("denied");

// Folder-internal. One stable URL per key while fresh.
export const urlCache = new LRUCache<string, string | typeof DENIED>({
  max: URL_CACHE_MAX_ENTRIES,
  ttl: SIGNED_URL_SAFE_TTL_MS,
});

export const pendingBatches = new Map<string, Promise<string | null>>();

export const cacheKeyOf = (projectId: string, key: string): string =>
  `${projectId}:${key}`;

export const setCachedUrl = (cacheKey: string, url: string | null): void => {
  urlCache.set(cacheKey, url ?? DENIED);
};

export const getCachedUrl = (cacheKey: string): string | null | undefined => {
  const cached = urlCache.get(cacheKey);
  if (cached === undefined) return undefined;
  return cached === DENIED ? null : cached;
};
